import { Box, Card, CardContent, Container, Grid } from "@mui/material";
import {
  InfoOperater,
  Loading,
  Poruka,
  XMLDatoteka,
  XMLDatotekaErrorButtonDownload,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useMojiPodaci } from "../../hooks";
import { fetcherBlob } from "../../utils/fetcher";
import { useEffect, useMemo, useRef, useState } from "react";

interface FormValues {
  certifikat: Blob | null;
  loading: Boolean;
  infoPoruka?: string;
  tipInfoPoruke?: number;
  "uploadXmlFile.xmlDatotekaAttachment": string | null;
}

const defaultValues = {
  certifikat: null,
  loading: false,
  "uploadXmlFile.xmlDatotekaAttachment": null,
};

const Index = () => {
  const methods = useForm<FormValues>({ defaultValues });
  const datotekaGreska = methods.watch("uploadXmlFile.xmlDatotekaAttachment");
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [data, setData] = useState<Blob | null>(null);
  const { operaterPlatforme } = useMojiPodaci(methods);

  useEffect(() => {
    const fetchData = async () => {
      methods.setValue("loading", true);
      const response = await fetcherBlob(
        `${process.env.REACT_APP_API_URL}/operateri/upute`,
        {}
      );
      setData(response);
      methods.setValue("loading", false);
    };
    fetchData();
  }, []);

  const url = useMemo(() => {
    if (!data || linkRef.current === null) return "/";
    linkRef.current.download = "Tehničke upute za korisnike.pdf";
    return window.URL.createObjectURL(new File([data], "filename.pdf"));
  }, [data]);

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box component={"form"}>
              <InfoOperater />
              <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
                <CardContent>
                  <p>
                    Datoteke veličine do 5 MB moguće je prenijeti kroz web
                    sučelje, za veće datoteke potrebno je koristiti pozivanje
                    servisa (kartica Pristup servisu).
                  </p>
                  <p>
                    Izvještajna datoteka predana kroz web sučelje mora
                    zadovoljavati zahtjeve propisane{" "}
                    <a ref={linkRef} href={url}>
                      Tehničkom specifikacijom za korisnike
                    </a>
                    . Nakon predaje datoteka prolazi kroz validaciju po
                    definiranim pravilima.
                  </p>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <XMLDatoteka />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Loading />
      <Poruka
        dialogActions={
          datotekaGreska ? <XMLDatotekaErrorButtonDownload /> : null
        }
        onClose={() => {
          // @ts-ignore
          methods.setValue("uploadXmlFile.xmlDatotekaAttachment", null);
        }}
      />
    </FormProvider>
  );
};

export default Index;
